import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { getPaymentDetails } from './data/DetailPurchase';
import { getResponseDetails } from './data/DetailsHistoryPrepaid';
import { getIdentifierMPDetails } from './data/DetailsMercadoPago';
import { getIdentifierDetails } from './data/DetailsNetPay';
import { getAuthorizationDetails } from './data/DetailsOpenPay';
import { getPurchasePaymentMethodAiralo } from './data/DetailsPurchaseAiralo';
import { getTrackingDetailsSTP } from './data/DetailsSTP';
import { getIdentifiersStripe } from './data/DetailsStripe';
import { getTrackingDetailsToku } from './data/DetailsToku';
import { getIdentifiersVinculation } from './data/DetailsVinculationOrders';
import { getIdentifiersYuno } from './data/DetailsYuno';

const titleStyle = { color: '#7A3C92' };
const spanStyle = { fontSize: 15, wordWrap: 'break-word' };
const valueStyle = {
  textAlign: 'right',
  marginTop: '5px',
  wordWrap: 'break-word',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const OrderIdentifiersGrid = ({ orderDetails, title, type }) => {
  let items = [];
  if (type === 'detailsSTP') {
    items = getTrackingDetailsSTP(orderDetails);
  } else if (type === 'detailsToku') {
    items = getTrackingDetailsToku(orderDetails);
  } else if (type === 'detailsNetPay') {
    items = getIdentifierDetails(orderDetails);
  } else if (type === 'detailsHistoryPrepaid') {
    items = getResponseDetails(Array.isArray(orderDetails) ? orderDetails[0] : orderDetails);
  } else if (type === 'detailPurchase') {
    items = getPaymentDetails(orderDetails);
  } else if (type === 'detailsOpenPay') {
    items = getAuthorizationDetails(orderDetails);
  } else if (type === 'detailsMercadoPago') {
    items = getIdentifierMPDetails(orderDetails);
  } else if (type === 'DetailsVinculationOrders') {
    items = getIdentifiersVinculation(orderDetails);
  } else if (type === 'detailsStripe') {
    items = getIdentifiersStripe(orderDetails[0]);
  } else if (type === 'detailsYuno') {
    items = getIdentifiersYuno(orderDetails[0]);
  } else if (type === 'AiraloDetails') {
    items = getPurchasePaymentMethodAiralo(orderDetails);
  }

  return (
    <Grid container className='device-info'>
      <Grid item size={{ xs: 12 }}>
        <div>
          <span style={titleStyle}>{title}</span>
        </div>
      </Grid>

      <Grid item size={{ xs: 12 }}>
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '5px',
              wordWrap: 'break-word',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            <span style={spanStyle}>{item.label}:</span>
            <Typography variant='body1' style={valueStyle}>
              {item.value || 'N/A'}
            </Typography>
          </div>
        ))}
      </Grid>
    </Grid>
  );
};

export default OrderIdentifiersGrid;
